import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';

document.addEventListener('DOMContentLoaded', function () {
  const data = formsObject; // eslint-disable-line
  const ajax_url = formsObject.ajax_url; // eslint-disable-line

  if (!data || !data.forms) return;

  let postalCodeInput = null;
  let districtSelect = null;
  let citySelect = null;
  let districtValue = null;
  let cityValue = null;
  let mrcValue = null;
  let arValue = null;
  let tomSelectDistrictInstance = null;
  let tomSelectCityInstance = null;

  data.forms.forEach((form) => {
    const formId = document.querySelector('#gform_' + form.form.id);
    if (formId) {
      form.form.adminLabels.forEach((label) => {
        if (label.postal_code) {
          postalCodeInput = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
        }
        if (label.district) {
          districtSelect = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
          tomSelectDistrictInstance = new TomSelect(districtSelect, {
            create: false,
            maxItems: 1,
            persist: true,
            hideSelected: true,
            allowEmptyOption: true,
          });
        }
        if (label.city) {
          citySelect = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
          tomSelectCityInstance = new TomSelect(citySelect, {
            create: false,
            maxItems: 1,
            persist: true,
            hideSelected: true,
            allowEmptyOption: true,
          });
        }
        if (label.district_value) {
          districtValue = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
        }
        if (label.city_value) {
          cityValue = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
        }
        if (label.mrc_value) {
          mrcValue = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
        }
        if (label.ar_value) {
          arValue = document.querySelector(
            '#input_' + form.form.id + '_' + label.id
          );
        }
      });
    }
  });

  if (postalCodeInput) {
    postalCodeInput.addEventListener('input', function () {
      const rawValue = this.value.toUpperCase().replace(/[^A-Za-z0-9]/g, ''); // Supprime les caractères non valides
      let formattedValue = '';

      if (rawValue.length > 0)
        formattedValue += rawValue.charAt(0).replace(/[^A-Za-z]/g, '');
      if (rawValue.length > 1)
        formattedValue += rawValue.charAt(1).replace(/[^0-9]/g, '');
      if (rawValue.length > 2)
        formattedValue += rawValue.charAt(2).replace(/[^A-Za-z]/g, '');
      if (rawValue.length > 3)
        formattedValue += ' ' + rawValue.charAt(3).replace(/[^0-9]/g, '');
      if (rawValue.length > 4)
        formattedValue += rawValue.charAt(4).replace(/[^A-Za-z]/g, '');
      if (rawValue.length > 5)
        formattedValue += rawValue.charAt(5).replace(/[^0-9]/g, '');

      this.value = formattedValue;

      const postalCode = postalCodeInput.value.trim();

      if (postalCode.length > 5) {
        fetch(ajax_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'get_data_by_postal_code',
            code_postal: postalCode,
          }),
        })
          .then((response) => response.json())
          .then((dataResponse) => {
            if (tomSelectCityInstance && tomSelectDistrictInstance) {
              tomSelectCityInstance.clear();
              tomSelectDistrictInstance.clear();
              tomSelectCityInstance.clearOptions();
              tomSelectDistrictInstance.clearOptions();
              if (dataResponse.length > 0) {
                dataResponse.forEach((resp) => {
                  tomSelectCityInstance.addOption({
                    value: resp.ville,
                    text: resp.ville,
                  });
                  tomSelectDistrictInstance.addOption({
                    value: resp.arrondissement,
                    text: resp.arrondissement,
                  });
                });
                tomSelectCityInstance.setValue(dataResponse[0].ville, true);
                tomSelectDistrictInstance.setValue(
                  dataResponse[0].arrondissement,
                  true
                );
                if (!dataResponse[0].disabled) {
                  cityValue.value = dataResponse[0].ville;
                  districtValue.value = dataResponse[0].arrondissement;
                  if (mrcValue) {
                    mrcValue.value = dataResponse[0].mrc;
                  }
                  if (arValue) {
                    arValue.value = dataResponse[0].regionadmin;
                  }
                }
              }
              tomSelectCityInstance.refreshOptions(false); // false pour éviter l'ouverture automatique
              tomSelectDistrictInstance.refreshOptions(false); // false pour éviter l'ouverture automatique
            }
          })
          .catch((error) => console.error('Erreur AJAX :', error));
      }
    });
  }
  function updateMrcAndRegionAdmin(dataResp) {
    if (!Array.isArray(dataResp) || dataResp.length === 0 || !dataResp[0]) {
      return;
    }
    if (dataResp[0].mrc) mrcValue.value = dataResp[0].mrc;
    if (dataResp[0].regionadmin) arValue.value = dataResp[0].regionadmin;
  }
  tomSelectCityInstance.on('change', function () {
    const postalCode = postalCodeInput.value.trim();
    cityValue.value = tomSelectCityInstance.getValue();

    fetch(ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'get_data_by_city',
        code_postal: postalCode,
        city: cityValue.value,
      }),
    })
      .then((response) => response.json())
      .then((dataR) => {
        updateMrcAndRegionAdmin(dataR);
      })
      .catch((error) => console.error('Erreur AJAX :', error));
  });
  tomSelectDistrictInstance.on('change', function () {
    districtValue.value = tomSelectDistrictInstance.getValue();
  });
});
